import Vue from 'vue';
import VueRouter from 'vue-router';

import Contact from './pages/Contact.vue';
import Contributor from './pages/admin/Contributor.vue';
import Home from './pages/Home.vue';
import Login from './pages/Login.vue';
import NotFound from './pages/404.vue';
import Request from './pages/Request.vue';
import User from './pages/admin/User.vue';

Vue.use(VueRouter);

const ifAuthenticated = (to, from, next) => {
    // console.log(Vue.localStorage.get('token'));
    if (Vue.localStorage.get('token') != null) {
      // console.log("NEXT " + JSON.stringify(to));
      next();
    } else {
      next('/login');
    }
}

const routes = [
    {
      name: 'Login',
      path: '/login',
      component: Login
    },
    {
      name: 'Home',
      path: '/',
      component: Home,
      beforeEnter: ifAuthenticated
    },
    {
      name: 'Request',
      path: '/requests',
      component: Request,
      beforeEnter: ifAuthenticated
    },
    {
      name: 'Users',
      path: '/admin/users',
      component: User,
      beforeEnter: ifAuthenticated
    },
    {
      name: 'Contributors',
      path: '/admin/contributors',
      component: Contributor,
      beforeEnter: ifAuthenticated
    },
    {
      name: 'Contact',
      path: '/contact',
      component: Contact
    },
    {
      path: '/404',
      component: NotFound
    },
    { path: '*', redirect: '/404' }, 
  ];
  
  const router = new VueRouter({ mode: 'history', routes: routes});
  
  export default router;